export const CUSTOM_ACTION_LIST_PAGE_SIZE = 25;

export enum CustomActionPayloadType {
	CURRENT_SELECTION = 'currentSelection',
}

export enum CustomActionContextName {
	CURRENT_SELECTION = 'selection',
}
